export enum ResourceMode {
    VIEW = 'VIEW',
    CREATE = 'CREATE',
    EDIT = 'EDIT',
    ADMIN = 'ADMIN'
}
  